module.exports = __webpack_public_path__ + "assets/img/ps-0.387d5b48.png";